import React from 'react';
import PropTypes from 'prop-types';

import classes from './WireTableNotes.css';
import translation from '../../../../assets/data/LocalizedStrings/LocalizedStrings.json';

const wireTableNotes = props => {
  const { country, language } = props;

  let noteFormula1 = translation[language]['rw75notes'],
    noteFormula2 = translation[language]['t90notes'],
    noteText1 = translation[language]['canadianTableNote1'],
    noteText2 = translation[language]['canadianTableNote2'],
    noteText3 = translation[language]['canadianTableNote3'];

  if (country === 'USA') {
    noteFormula1 = translation[language]['THWNotes'];
    noteFormula2 = translation[language]['THHNNotes'];
    noteText1 = translation[language]['usaTableNote1'];
  }
  if (country === 'Canada') {
    noteFormula1 = translation[language]['rw75notes'];
    noteFormula2 = translation[language]['t90notes'];
    noteText1 = translation[language]['canadianTableNote1'];
    noteText2 = translation[language]['canadianTableNote2'];
    noteText3 = translation[language]['canadianTableNote3'];
  }
  return (
    <div className={classes.TableNotes}>
      <p>
        {noteFormula1}
        <br />
        {noteFormula2}
      </p>
      <p>
        <span className={classes.NoteSpan}>
          {translation[language]['note']}:{' '}
        </span>
        {noteText1}
      </p>
      {country === 'Canada' ? (
        <p>
          <span className={classes.NoteSpan}>
            {translation[language]['note']}:{' '}
          </span>
          <br />
          {noteText2}
          <br />
          {noteText3}
        </p>
      ) : null}
    </div>
  );
};

wireTableNotes.propTypes = {
  language: PropTypes.string.isRequired,
  country: PropTypes.string.isRequired
};

export default wireTableNotes;
